import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { menuList } from "../data/menu-list";
import { useWindowSize } from "../Hooks/WindowSize";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button } from "@mui/material";
import { updateIsInternRequest } from "../redux/action/profileAction";
import { engApi } from "../api/engApi";
import Copyright from "./Copyright";

const SideMenu = () => {
  const dispatch = useDispatch();
  const size = useWindowSize();
  const location = useLocation();
  const navigate = useNavigate();
  const profile = useSelector((state) => state.profileReducer.profile);
  // const isMember = useSelector((state) => state.profileReducer.isMember);
  // const isInternRequest = useSelector(
  //   (state) => state.profileReducer.isInternRequest
  // );

  // const profile = {
  //   b_id: "0",
  //   gpa: "4",
  //   id: "55050419",
  //   m_role: "student",
  //   name: "นายนรุตม์ สาหาร",
  //   status: "0",
  // };
  // const getUsername = 55050419;
  const getUsername = localStorage.getItem("username");

  const [internDetail, setInternDetail] = useState(null);
  const [isMember, setIsMember] = useState(false);
  const [isInternRequest, setIsInternRequest] = useState(false);
  const [internStudent, setInternStudent] = useState(null);

  const { pathname } = location;

  let mobileMode = false;
  if (size.width > 1000) {
    mobileMode = false;
  } else if (size.width > 300) {
    mobileMode = true;
  }

  const getInternMember = async () => {
    const resMember = await engApi.get("/intern-student/");

    try {
      const match = await resMember.data?.find((el) => el.id == getUsername);

      if (match) {
        setIsMember(true);
        setInternStudent(match);
      } else {
        setIsMember(false);
        setInternStudent(null);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getInternData = async () => {
    const response = await engApi.get("/get-internship-request/");

    try {
      const match = await response.data?.find((el) => el.st_id == getUsername);

      if (match) {
        // dispatch(updateIsInternRequest(true));
        setInternDetail(match);
        setIsInternRequest(true);
      } else {
        setIsInternRequest(false);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getInternMember();
    getInternData();
  }, [profile]);

  const displayMenu = (
    <ul className="sidebar-nav">
      {profile && profile.m_role == "staff" && (
        <>
          <li className="sidebar-item">
            <a
              data-bs-target="#dashboard"
              data-bs-toggle="collapse"
              className="sidebar-link collapsed"
            >
              สรุปข้อมูล
            </a>
            <ul
              id="dashboard"
              className="sidebar-dropdown list-unstyled collapse show"
              data-bs-parent="#sidebar"
            >
              <Link className="sidebar-link" to="/dashboard">
                แยกตามรายชื่อนิสิต
              </Link>

              <Link className="sidebar-link" to="/dashboard-company">
                แยกตามรายชื่อบริษัท
              </Link>
            </ul>
          </li>

          {profile?.b_id == 0 && (
            <li className="sidebar-item">
              <a
                data-bs-target="#document-management"
                data-bs-toggle="collapse"
                className="sidebar-link collapsed"
              >
                จัดการเอกสาร
              </a>
              <ul
                id="document-management"
                className="sidebar-dropdown list-unstyled collapse show"
                data-bs-parent="#sidebar"
              >
                <Link className="sidebar-link" to="/task">
                  หนังสือขอความอนุเคราะห์
                </Link>

                <Link className="sidebar-link" to="/internship-answer">
                  แบบตอบรับฝึกงาน/หนังสือส่งตัว
                </Link>
              </ul>
              <Link className="sidebar-link" to="/event">
                การอบรมเตรียมความพร้อม
              </Link>
              <Link className="sidebar-link" to="/student-manage">
                จัดการข้อมูลนิสิต
              </Link>
            </li>
          )}

          <Link className="sidebar-link" to="/approval">
            อนุมัติคำขอฝึกงาน
          </Link>
          <Link className="sidebar-link" to="/company-review">
            จัดการสถานประกอบการใหม่
          </Link>
        </>
      )}

      {profile && profile.m_role == "student" && (
        <>
          <Link className="sidebar-link" to="profile">
            Profile
          </Link>
          {!isMember && (
            <Link className="sidebar-link" to="/student-form">
              Form
            </Link>
          )}

          {(!internDetail ||
            internStudent?.status_id == "15" ||
            internStudent?.status_id == "32") && (
            <Link className="sidebar-link" to="/request-form">
              ยื่นความประสงค์ขอฝึกงาน
            </Link>
          )}
        </>
      )}

      <>
        <Link className="sidebar-link" to="/company-detail">
          ข้อมูลสถานประกอบการ
        </Link>
        <Link className="sidebar-link" to="/job-request">
          ข้อมูลสถานประกอบการที่แจ้งรับนิสิต
        </Link>

        <Link className="sidebar-link" to="/manual">
          คู่มือ
        </Link>
      </>
    </ul>
  );

  const displayNav = (
    <nav id="sidebar" className="">
      <div className="sidebar-content js-simplebar ">
        {profile ? (
          displayMenu
        ) : (
          <Box display="flex" justifyContent="center">
            <Button color="primary" onClick={() => navigate("/login")}>
              Login
            </Button>
          </Box>
        )}
      </div>
    </nav>
  );

  const displayStaticMenu = (
    <div className="w-100 p-3">
      <div>
        <div className="mb-6 text-center" id="offcanvasScrollingLabel">
          <Link to="/">
            <img src="./assets/images/logo_white.png" alt="logo" width="75%" />
          </Link>
        </div>
      </div>
      {displayNav}
    </div>
  );

  const displaySlideMenu = (
    <>
      <div>
        <div
          className="offcanvas offcanvas-start"
          tabIndex={-1}
          id="offcanvasExample"
          aria-labelledby="offcanvasExampleLabel"
          style={{
            backgroundColor: "#283042",
          }}
        >
          <div className="offcanvas-header m-auto">
            <Link to="/" className="offcanvas-title" id="offcanvasExampleLabel">
              <img
                src="./assets/images/logo_white.png"
                alt="logo"
                width="200px"
              />
            </Link>
          </div>
          <div className="offcanvas-body pb-4" style={{ fontSize: "18px" }}>
            {displayNav}
          </div>
        </div>
      </div>
    </>
  );

  return (
    <div
      className="w-100 "
      style={{
        backgroundColor: "#283042",
        minHeight: window.innerHeight,
        position: "relative",
      }}
    >
      {displayStaticMenu}
      {/* {!mobileMode ? displayStaticMenu : displaySlideMenu} */}
      <div className="ps-2" style={{ position: "absolute", bottom: "0" }}>
        <Copyright color="white" variant="caption" />
      </div>
    </div>
  );
};

export default SideMenu;
